import React from "react";
import Slider from "react-slick";
import { trustedByBrandsContent } from "../../content/home/trustedByBrandsContent";

const TrustedByBrands: React.FC = () => {
    const { title, brands, sliderSettings } = trustedByBrandsContent;

    return (
        <section className="text-center py-16 bg-[#FFFDF8] mt-10">
            <h3
                className="text-[40px] font-normal mb-10"
                style={{ fontFamily: "Roboto Serif" }}
            >
                {title}
            </h3>

            <div className="max-w-7xl mx-auto">
                <Slider {...sliderSettings}>
                    {brands.map((brand, index) => (
                        <div key={index} className="px-4">
                            <img
                                src={brand.image}
                                alt={brand.alt}
                                className="h-16 md:h-20 lg:h-24 mx-auto object-contain opacity-80 hover:opacity-100 transition duration-300"
                            />
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
};

export default TrustedByBrands;